module.exports = __webpack_public_path__ + "img/brand_instagram.df38463e.svg";